(ns renolit-roofing-service.view.rae-home
  (:require ["@googlemaps/markerclusterer" :refer [MarkerClusterer]]
            [re-frame.core :as rf]
            ["react" :refer [useEffect]]
            [reagent.core :as r]
            [renolit-roofing-service.config :as config]
            [renolit-roofing-service.entity-list :as entity-list]
            [renolit-roofing-service.layout.components :refer [link-button]]
            [renolit-roofing-service.layout.grid-table :as layout.grid-table]
            [renolit-roofing-service.layout.icon :as layout.icon]
            [renolit-roofing-service.layout.user-layout :as user-layout]
            [renolit-roofing-service.localization :refer [t]]
            [renolit-roofing-service.navigation :as nav]
            [renolit-roofing-service.service.project :as srv.project]
            [renolit-roofing-service.user :as client.user]
            [renolit-roofing-service.shared.util.time :as shared.time]
            [renolit-roofing-service.view :as view]
            ["recharts" :refer [Cell Pie PieChart ResponsiveContainer Legend]]
            ["@vis.gl/react-google-maps" :refer [APIProvider Map AdvancedMarker useMap useMapsLibrary]]))


(def ^:const route-config
  {:name [:home]
   :auth-req? true
   :parameters {}
   :controllers [{:start #(rf/dispatch [::view.on-enter %])
                  :stop #(rf/dispatch [::view.on-leave %])}]})

(def ^:const entity-key :dashboard-project-list)

(rf/reg-event-fx
 ::load-list-data
 (fn [_ [_ opts]]
   {:fx [[:dispatch [::entity-list/load-list
                     (merge
                      {:entity-key entity-key
                       :uri "/api/projects"
                       :extra-params {:cols [:id :number :name :installation-date :building-street :building-city :building-zip]
                                      :pagination {:page-size 9}}}
                      opts)]]]}))

(rf/reg-event-fx
 ::view.on-enter
 (fn [_ _]
   {:fx [[:dispatch [::srv.project/get-projects-stats]]
         [:dispatch [::load-list-data]]]}))

(rf/reg-event-fx
 ::set-project-location
 (fn [{:keys [db]} [_ project-id location]]
   {:db (assoc-in db [:address-location project-id] location)}))

(rf/reg-event-fx
 ::view.on-leave
 (fn [{:keys [_]} _]))

(rf/reg-sub
 ::get-project-location
 (fn [db [_ project-id]]
   (get-in db [:address-location project-id])))

(defn render-customized-label
  [{:strs [cx cy midAngle innerRadius outerRadius percent]}]
  (let [RADIAN (/ js/Math.PI 180)
        radius (+ innerRadius (* 0.5 (- outerRadius innerRadius)))
        angle (or midAngle 0)
        x (+ cx (* radius (js/Math.cos (* -1 angle RADIAN))))
        y (+ cy (* radius (js/Math.sin (* -1 angle RADIAN))))]
    (r/as-element [:text {:x x
                          :y y
                          :fill "white"
                          :text-anchor (if (> x cx) "start" "end")
                          :dominant-baseline "central"}
                   (str (.toFixed (* (or percent 1) 100) 0) "%")])))

(defn legent-counts
  [_value entry _index]
  (str entry.payload.name " (" entry.payload.value ")"))

(defn pie-chart
  [data]
  (let [colors ["#00426A" "#0074BB"]]
    [:> ResponsiveContainer {:width "100%" :height "100%"}
     [:> PieChart {:width 400 :height 400}
      [:> Legend {:layout "vertical" :align "right" :verticalAlign "middle" :formatter legent-counts}]
      [:> Pie {:data data
               :cx "50%"
               :cy "50%"
               :labelLine false
               :label #(render-customized-label (js->clj %))
               :outerRadius 80
               :fill "#8884d8"
               :dataKey "value"}
       (doall
        (map-indexed
         (fn [idx {:keys [name]}]
           ^{:key (str "cell-" name)}
           [:> Cell {:fill (nth colors (mod idx (count colors)))}])
         data))]]]))

(defn registered-projects-card
  [{:keys [total requiring-review]}]
  [:div.home__stats-item
   [:div.home__stats-item-label
    (t [:page.home.registered-projects])]
   [:div.home__stats-item-num
    total]
   [:div.home__stats-item-tooltip
    [layout.icon/icon {:key :info}]
    requiring-review " " (t [:page.home.need-review])]])

(defn projects-stats-pie-chart-card
  [{:keys [title-transl-kw href query-params data]}]
  [:div.home__stats-item
   [:div.home__stats-item-label
    (t [title-transl-kw])]
   [:div.home__stats-item-chart
    [pie-chart data]]
   [link-button
    (t [:page.home.view-list])
    (nav/href href nil query-params)]])

(defn- project-review-stats
  [projects-stats]
  (let [analyzed-project-count (- (:total projects-stats) (:requiring-review projects-stats))
        projects-review-stats [{:name (t [:page.home.analyzed]) :value analyzed-project-count}
                               {:name (t [:page.home.pending-analysis]) :value (:requiring-review projects-stats)}]]
    [projects-stats-pie-chart-card {:data projects-review-stats
                                    :title-transl-kw :page.home.projects-need-review
                                    :href [:project-list]
                                    :query-params {:requires-review "true"}}]))

(defn- projects-age-stats
  [projects-stats]
  (let [projects-age-stats [{:name (t [:page.home.less-than-10-years]) :value (:aged-lt-10-years projects-stats)}
                            {:name (t [:page.home.more-than-10-years]) :value (:aged-gt-10-years projects-stats)}]]
    [projects-stats-pie-chart-card {:data projects-age-stats
                                    :title-transl-kw :page.home.age-of-projects
                                    :href [:project-list]
                                    :query-params {:aged-gt-10-years "true"}}]))

(defn geocode-center
  [project-id address]
  (let [geocoding-lib (useMapsLibrary "geocoding")]
    (useEffect
     (fn []
       (when (and geocoding-lib address)
         (let [^google.maps.GeocodingLibrary.Geocoder geocoder (new (.-Geocoder geocoding-lib))]
           (-> (.geocode geocoder (clj->js {:address address}))
               (.then (fn [response]
                        (let [resp (js->clj response {:keywordize-keys true})
                              loc (get-in resp [:results 0 :geometry :location])]
                          (rf/dispatch [::set-project-location project-id loc])))))))
       js/undefined)
     #js [geocoding-lib, address])
    [:<>]))

(defonce markers* (r/atom {}))

(defonce clusterer* (atom nil))

(defn create-cluster-renderer
  []
  (clj->js
   {:render
    (fn [cluster]
      (let [div (.createElement js/document "div")]
        (set! (.-className div) "home__main-map-circle")
        (set! (.-innerText div) (.-count cluster))
        (js/google.maps.marker.AdvancedMarkerElement.
         (clj->js
          {:position (.-position cluster)
           :content div}))))}))

(defn MarkerClusterLayer []
  (let [map (useMap)]
    (useEffect
     (fn []
       (if map
         (let [c (MarkerClusterer. (clj->js {:map map :renderer (create-cluster-renderer)}))]
           (reset! clusterer* c)
           (fn []
             (.setMap c nil)
             (reset! clusterer* nil)))
         js/undefined))
     #js [map])
    (useEffect
     (fn []
       (when @clusterer*
         (.clearMarkers ^MarkerClusterer @clusterer*)
         (.addMarkers ^MarkerClusterer @clusterer* (->> @markers* vals (filter some?) clj->js)))
       js/undefined)
     #js [@clusterer* @markers*])
    nil))

(defn- projects-locations-gmap
  [projects]
  (let [{:keys [google-maps-api-key]} @(rf/subscribe [::config/config-data])]
    [:div.home__main-map
     [:> APIProvider
      {:apiKey google-maps-api-key}
      [:> Map
       {:mapId "DEMO_MAP_ID"
        :defaultCenter {:lat 40.463667 :lng -3.74922} ;; spain center
        :defaultZoom 7}
       (doall
        (for [{:keys [id building-street building-city]} projects]
          (let [address (str building-street ", " building-city)
                location @(rf/subscribe [::get-project-location id])]
            ^{:key id}
            [:<>
             [:f> geocode-center id address]
             [:> AdvancedMarker {:position location
                                 :title address
                                 :onClick #(rf/dispatch [::nav/push-state [:project] {:project-id id}])
                                 :ref (fn [marker]
                                        (swap! markers* assoc id marker))}]])))]
      [:> MarkerClusterLayer]]]))

(defn- main*
  []
  (let [projects-stats @(rf/subscribe [::srv.project/projects-stats])
        projects-entities @(rf/subscribe [::entity-list/list entity-key])]
    [:div.home
     [:div.home__stats
      [registered-projects-card projects-stats]
      [project-review-stats projects-stats]
      [projects-age-stats projects-stats]]
     [:div.home__main
      [projects-locations-gmap projects-entities]
      [:div.home__main-projects
       [:div.home__main-projects-header
        [:h2 (t [:page.home.latest-projects-registered])]
        [link-button (t [:page.home.see-full-list]) (nav/href [:project-list])]]
       [layout.grid-table/main
        {:data projects-entities
         :grid-header-extra-class "grid-table__header--project-list"
         :grid-row-extra-class "grid-table__row--project-list"
         :row-href-fn #(nav/href [:project] {:project-id (:id %)})
         :cols [{:id :project-number
                 :path [:number]
                 :title-transl-kw :page.project.list.table-header.id
                 :cell-settings {:type :text}}
                {:id :project-name
                 :path [:name]
                 :title-transl-kw :page.project.list.table-header.name
                 :cell-settings {:type :text}}
                {:id :project-installation-date
                 :path [:installation-date]
                 :title-transl-kw :page.project.list.table-header.installation-date
                 :cell-settings {:type :custom
                                 :component (fn [project-installation-date]
                                              (let [formatted (shared.time/format-date project-installation-date {})]
                                                [:div.grid-table__cell
                                                 [:div.media-grid-item
                                                  [:span
                                                   formatted]]]))}}
                {:id :nav-button
                 :path [:id]
                 :cell-settings {:type :custom
                                 :component (fn [_]
                                              [layout.icon/icon {:class ["arrow-link"]
                                                                 :key :right-arrow}])}}]}]]]]))

(defn- main
  []
  (let [user (rf/subscribe [::client.user/user-data])]
    (fn []
      (let [{:keys [first-name]} @user]
        [user-layout/main
         {:header-title (t [:page.home.user-greetings] [first-name])}
         [main*]]))))

(defmethod view/view-display (:name route-config)
  [_]
  [main])
